export const UnsavedChangesGlobalKey = 'global';
